/* shrine.null.js - helpers globales del tema Shrine */

/**
 * Pausa cualquier tipo de media que esté reproduciéndose
 * (videos, audios, iframes dentro de .deferred-media, etc.)
 * El tema espera que window.pauseAllMedia exista.
 */
window.pauseAllMedia = window.pauseAllMedia || function () {
  const selectors = [
    'video',
    'audio',
    'model-viewer',
    '.deferred-media iframe',
    '.deferred-media video',
    '.deferred-media audio'
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      const tag = el.tagName && el.tagName.toLowerCase();

      if ((tag === 'video' || tag === 'audio') && typeof el.pause === 'function') {
        try { el.pause(); } catch (e) {}
      }

      if (tag === 'model-viewer' && typeof el.pause === 'function') {
        try { el.pause(); } catch (e) {}
      }

      // Iframe (por ejemplo YouTube/Vimeo) dentro de deferred-media
      if (tag === 'iframe') {
        try {
          const src = el.src;
          el.src = src; // forzamos reload para detener la reproducción
        } catch (e) {}
      }
    });
  });
};
